"use client"

import { ServerCog } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ServerCogIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ServerCogIcon = component(Icon)({ as: ServerCog })
